import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../primaryComponents";
import { useValidateGiftCard } from "../../../../hooks/api/mutations/useLoyalty";
import { useContext, useState } from "react";
import { Controller } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { addGiftcard } from "../../../../store/modules/checkoutInfo";
import { useValidation } from "./useValidation";
import { ToastContext } from "../../../../hooks/context";
import { useOtpAuthTrigger } from "../../../../hooks/useOtpAuthTrigger";
import { useParams } from "react-router-dom";

export const GiftCode = ({
  currency_symbol,
  loyaltyType,
  closeModal = () => {},
}) => {
  const { store_id } = useParams();
  const dispatch = useDispatch();
  const triggerToast = useContext(ToastContext);
  const [amount, setAmount] = useState("");
  const [redemptionCode, setRedemptionCode] = useState("");
  const [validatedData, setValidatedData] = useState(null);
  const {
    control,
    formState: { errors },
    trigger,
    handleSubmit,
  } = useValidation({ loyaltyType });
  const { handleOrderModuleAuth, isLoadingAuthAction } = useOtpAuthTrigger({
    storeId: store_id,
    params: {},
  });

  const { mutate: validateGiftCard, isLoading: isValidating } =
    useValidateGiftCard();

  const handleValidateGiftCard = () => {
    validateGiftCard(
      { redemption_code: redemptionCode },
      {
        onSuccess: (res) => {
          setValidatedData(res?.data?.data);
        },
      },
    );
  };

  const setGiftcard = () => {
    dispatch(
      addGiftcard({
        redemption_code: redemptionCode,
        amount,
      }),
    );
  };

  const handleSetGiftcard = () => {
    if (!validatedData) {
      return triggerToast(
        "Click 'Retrieve' to retrieve gift card details",
        "warning",
      );
    }
    if (
      validatedData &&
      Number(amount) > Number(validatedData?.giftcard_available_balance)
    ) {
      return triggerToast(
        "Gift card amount is greater than available balance",
        "warning",
      );
    }

    handleOrderModuleAuth({
      actionKey: "use_giftcard_on_order",
      onSuccessCallBack: () => {
        setGiftcard();
        closeModal();
      },
    });
    setGiftcard();
  };

  return (
    <>
      <form
        className={styles.contentContainer}
        id="giftcardForm"
        onSubmit={handleSubmit(handleSetGiftcard)}
      >
        <div>
          <label>
            <span className="text-danger">*</span>
            <span>Gift Card Code</span>
          </label>
          <Controller
            name={"redemption_code"}
            control={control}
            render={({ field: { onChange } }) => (
              <div className={styles.giftCardInputContainer}>
                <input
                  name="redemption_code"
                  className={styles.giftCardInput}
                  type="text"
                  placeholder="Enter gift card code"
                  value={redemptionCode}
                  // {...register("redemption_code", { required: true })}
                  onChange={(val) => {
                    const value = val?.target?.value;
                    onChange(value);
                    setRedemptionCode(value);
                  }}
                />
                <primaryComponents.Button
                  classNames={"btn btn--outline smallBtn"}
                  onClick={() => handleValidateGiftCard()}
                  loadingText={"Validating..."}
                  isDisabled={redemptionCode?.length === 0 || isValidating}
                >
                  Retrieve
                </primaryComponents.Button>
              </div>
            )}
          />
          {errors?.redemption_code?.message && (
            <p className="error-message text-danger small-text-size">
              <FontAwesomeIcon
                icon={["fas", "exclamation-circle"]}
                className="mr-2"
                style={{ fontSize: "13px" }}
              />
              <span>{errors?.redemption_code?.message}</span>
            </p>
          )}
        </div>

        <div
          className={globalStyles.cardWithBackground}
          style={{ background: "rgba(243, 243, 243, 1)" }}
        >
          <h6 className="mb-0">Gift Card Details</h6>
          <div
            className={`${globalStyles.cardWithBorder} white w-100`}
            style={{ borderRadius: 0 }}
          >
            <div className={"text-center"}>
              <p className={`${styles.availableBalance} small-text-size`}>
                Available Balance
              </p>
              <h5 className="text-center mb-0">
                {validatedData
                  ? `${currency_symbol} ${validatedData?.giftcard_available_balance}`
                  : "-"}
              </h5>
            </div>
          </div>
        </div>

        <primaryComponents.InputFieldV2
          control={control}
          name="amount"
          label={`Amount (${currency_symbol})`}
          classNames="white"
          placeholder="Enter amount to take out of your giftcard balance"
          isRequired={true}
          value={amount}
          type="number"
          min="0"
          floatError={false}
          onChange={({ target: { value } }) => {
            setAmount(value);
          }}
          errorMessage={errors?.amount}
          onKeyUp={() => errors?.amount !== undefined && trigger("amount")}
        />
      </form>
      <primaryComponents.Button
        classNames={"btn btn--primary"}
        type="submit"
        form="giftcardForm"
        isLoading={isLoadingAuthAction}
      >
        Apply
      </primaryComponents.Button>
    </>
  );
};
